import scrollTo from 'utils/scrollTo';
class Carousel {
  /* eslint-disable complexity */
  constructor(element, options) {
    this._element = element;
    this._options = { ...Carousel.options, ...options };

    let bullets = [];
    let products = [];
    /* eslint-enable */
    if (this._options.bullet) {
      bullets = [...element.querySelectorAll(this._options.bullet)];
    }
    if (this._options.products) {
      products = [...element.querySelectorAll(this._options.products)];
    }
    this._refs = {
      window: element.querySelector(this._options.window),
      bullets,
      products,
      slides: [],
      prev: this._element.querySelector(this._options.prev),
      next: this._element.querySelector(this._options.next),
      body: document.querySelector('body'),
    };
    this._state = {
      index: 0,
      dragging: false,
      currentPos: 0,
      direction: 'right',
      touchStart: {
        x: 0,
        y: 0,
      },
    };

    this._refs.slides = [...this._refs.window.children];
    this._refs.window.scrollLeft = 0;
    this._element.setAttribute('data-initialized', 'true');

    if (this._options.bullet) {
      this._refs.bullets.forEach((bullet) => {
        bullet.addEventListener('click', (e) => this._onBulletClick(e));
      });
    }

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            this._refs.slides[this._state.index].setAttribute('data-active', 'false');
            this._state.index = parseInt(entry.target.getAttribute('data-index'), 10);
            this._state.currentPos = this._state.index;
            entry.target.setAttribute('data-active', 'true');
          } else {
            entry.target.setAttribute('data-active', 'false');
          }
          this.handleArrows();
        });
      },
      {
        root: this._refs.window,
        threshold: this._options.threshold,
      }
    );

    this._refs.slides.forEach((elem) => this.intersectionObserver.observe(elem));

    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.goto(this._state.index);
      }, this._options.timeout);
    });

    if (this._options.prev) {
      this._refs.prev.addEventListener('click', () => this.previous());
    }
    if (this._options.next) {
      this._refs.next.addEventListener('click', () => this.next());
    }
  }

  static options = {
    bullet: null,
    window: null,
    products: null,
    threshold: 0.8,
    bound: 0.66,
    breakpoint: 720,
    minmax: {
      min: 1,
      max: 2,
    },
    timeout: 300,
    pace: 1000,
  };

  get slideWidth() {
    return this._refs.slides[0].offsetWidth;
  }

  // eslint-disable-next-line accessor-pairs
  set activeBullet(index) {
    if (this._options.bullet) {
      this._refs.bullets.forEach((bullet, i) => {
        bullet.setAttribute('data-selected', index === i);
      });
    }
  }

  // eslint-disable-next-line accessor-pairs
  set activeProduct(index) {
    if (this._options.products) {
      this._refs.products.forEach((product, i) => {
        product.setAttribute('data-active', index === i);
      });
    }
  }

  _onBulletClick(e) {
    e.preventDefault();
    const index = this._refs.bullets.indexOf(e.target);
    if (index !== -1) this.goto(index);
  }

  goto(index) {
    const max = this._refs.slides.length - 1;
    const i = Math.min(Math.max(index, 0), max);

    this.slideTo(i);
    this.activeBullet = i;
    this.activeProduct = i;
    this._state.index = i;
  }

  previous() {
    this.goto(this._state.index - 1);
  }

  next() {
    this.goto(this._state.index + 1);
  }

  handleArrows() {
    if (this._state.index < 1) {
      this._refs.prev.setAttribute('data-enabled', false);
    } else {
      this._refs.prev.setAttribute('data-enabled', true);
    }
    if (this._state.index >= this._refs.slides.length - 1) {
      this._refs.next.setAttribute('data-enabled', false);
    } else {
      this._refs.next.setAttribute('data-enabled', true);
    }
  }

  slideTo(index) {
    const target = -index * this.slideWidth;
    // eslint-disable-next-line no-unused-expressions
    target <= this._state.currentPos
      ? (this._state.direction = 'left')
      : (this._state.direction = 'right');
    this._state.currentPos = target;
    if (this._options.bullet) {
      this._refs.bullets.forEach((bullet) => {
        bullet.setAttribute('data-direction', this._state.direction);
      });
    }

    //disable scrollsnap while animating
    this._refs.window.setAttribute('data-snap', false);
    const t = setTimeout(() => {
      this._refs.window.setAttribute('data-snap', true);
      clearTimeout(t);
    }, this._options.pace);
    this.handleArrows();
    //scroll the container into position
    scrollTo(this._refs.slides[index], target, this._options.pace, this._refs.window, 'x');
  }
}

export default Carousel;
